import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  return <header className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-114">
      <div className="container mx-auto px-6 md:px-12" data-id="element-115">
        <div className="flex justify-between items-center" data-id="element-116">
          <div className="flex items-center" data-id="element-117">
            <Link to="/" data-id="element-118">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2RuwY93x3ZTZ9LC7gBR1Jd/HM_Logo_Horizontal.jpg" alt="HiddenMatter" className="h-10 md:h-12" data-id="element-119" />
            </Link>
          </div>
          <nav className="hidden md:block" data-id="element-120">
            <ul className="flex space-x-8" data-id="element-121">
              <li className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-122">
                <button className="font-inter text-black hover:text-lime transition-colors" data-id="element-123">
                  Services
                </button>
                {servicesOpen && <div className="absolute top-full left-0 pt-2" data-id="element-124">
                    <div className="bg-white shadow-lg rounded-md py-2 min-w-[200px]" data-id="element-125">
                      <Link to="/perspective" className="block px-4 py-2 font-inter text-black hover:bg-lightgray transition-colors" onClick={() => setServicesOpen(false)} data-id="element-126">
                        Perspective
                      </Link>
                      <Link to="/purpose" className="block px-4 py-2 font-inter text-black hover:bg-lightgray transition-colors" onClick={() => setServicesOpen(false)} data-id="element-127">
                        Purpose
                      </Link>
                      <Link to="/principles" className="block px-4 py-2 font-inter text-black hover:bg-lightgray transition-colors" onClick={() => setServicesOpen(false)} data-id="element-128">
                        Principles
                      </Link>
                      <Link to="/practice" className="block px-4 py-2 font-inter text-black hover:bg-lightgray transition-colors" onClick={() => setServicesOpen(false)} data-id="element-129">
                        Practice
                      </Link>
                    </div>
                  </div>}
              </li>
              <li data-id="element-130">
                <Link to="/about" className="font-inter text-black hover:text-lime transition-colors" data-id="element-131">
                  About
                </Link>
              </li>
              <li data-id="element-132">
                <Link to="/contact" className="font-inter text-black hover:text-lime transition-colors" data-id="element-133">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
          <div className="md:hidden" data-id="element-134">
            <button className="text-black" data-id="element-135">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6" data-id="element-136">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" data-id="element-137" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>;
};
export default Navbar;